module.exports = __webpack_public_path__ + "img/zhifubaozhifu.51601d99.png";